export default __webpack_public_path__ + "static/media/HomeMe.449e3a06.png";